module.exports = __webpack_public_path__ + "static/media/group.c859db9e.svg";